/** What a member's cancellation of one occurrence costs them (wire string enum). */
export enum CancellationCharge {
  None = "None",
  FullPrice = "FullPrice",
  Fee = "Fee",
}
